/* eslint-disable max-len */
import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Field, Label } from 'rbx';

import {
  // CheckBox,
  // Radio,
  TextArea,
  CheckBox,
  InputAddOn,
  Radio,
  SelectTime,
  InputErrorMessage,
  Select,
  ReactDateTimePicker,
} from '../../../../components/elements';

const Container = styled.div`
  padding: 1rem;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 10px;
`;

const GridContainer2 = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-gap: 10px;
`;

const TableContainer = styled.div`
  margin-left: 30px;
  margin-bottom: 12px;
`;

const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    border: 1px solid #dbdbdb;
    padding: 6px 10px;
    vertical-align: middle;
    white-space: nowrap;
  }

  thead tr:first-child th {
    background: #e8e8e8;
    text-align: center;
    font-size: 0.85rem;
    font-weight: 600;
  }

  thead tr:second-child th,
  thead tr + tr th {
    background: #f5f5f5;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 500;
    color: #555;
  }

  tbody td {
    background: #fff;
    font-size: 0.85rem;
  }

  tbody tr:hover td {
    background: #fafafa;
  }

  td:last-child {
    text-align: center;
  }
`;

const DatePickerCell = styled.div`
  .field {
    margin-bottom: 0;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  input.input {
    font-size: 0.85rem;
    padding: 0.25em 0.5em;
    height: 2.25em;
  }
`;

const TimePickerCell = styled.div`
  min-width: 100px;
  input.input {
    font-size: 0.85rem;
    padding: 0.25em 0.5em;
    height: 2.25em;
  }
`;

const SpecificDatesTable = ({ config, disabled, onChange, onAdd }) => (
  <TableContainer>
    <StyledTable>
      {config.length !== 0 && (
        <thead>
          <tr>
            <th colSpan={2}>Order for date(s)</th>
            <th colSpan={4}>Ordering Window</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th colSpan={2}>
              From{' '}
              <span
                style={{ fontWeight: 400, color: '#999', fontSize: '0.75rem' }}
              >
                (optional)
              </span>
            </th>
            <th colSpan={2}>To</th>
            <th />
          </tr>
        </thead>
      )}
      <tbody>
        {(config || []).map((dateConfig, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={index}>
            <td>
              <DatePickerCell style={{ width: '190px' }}>
                <ReactDateTimePicker
                  value={dateConfig.date}
                  onChange={value => {
                    const newConfig = [...config];
                    newConfig[index] = { ...newConfig[index], date: value };
                    onChange(newConfig);
                  }}
                  disabled={disabled}
                  minDate={new Date()}
                  popperProps={{ strategy: 'fixed' }}
                />
              </DatePickerCell>
            </td>
            <td>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <TimePickerCell>
                  <SelectTime
                    value={dateConfig.option?.start}
                    disabled={disabled}
                    onChange={value => {
                      const newConfig = [...config];
                      const startInSec =
                        value.hours * 3600 + value.minutes * 60;
                      newConfig[index] = {
                        ...newConfig[index],
                        option: {
                          ...newConfig[index].option,
                          start: value.time,
                          start_in_sec: startInSec,
                        },
                      };
                      onChange(newConfig);
                    }}
                  />
                </TimePickerCell>
                <span style={{ padding: '0 4px' }}>to</span>
                <TimePickerCell>
                  <SelectTime
                    value={dateConfig.option?.end}
                    disabled={disabled}
                    onChange={value => {
                      const newConfig = [...config];
                      const endInSec = value.hours * 3600 + value.minutes * 60;
                      newConfig[index] = {
                        ...newConfig[index],
                        option: {
                          ...newConfig[index].option,
                          end: value.time,
                          end_in_sec: endInSec,
                        },
                      };
                      onChange(newConfig);
                    }}
                  />
                </TimePickerCell>
              </div>
            </td>
            <td>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <DatePickerCell style={{ width: '190px' }}>
                  <ReactDateTimePicker
                    value={dateConfig.cut_off_from_date}
                    onChange={value => {
                      const newConfig = [...config];
                      newConfig[index] = {
                        ...newConfig[index],
                        cut_off_from_date: value,
                      };
                      onChange(newConfig);
                    }}
                    disabled={disabled || !dateConfig.date}
                    minDate={new Date()}
                    popperProps={{ strategy: 'fixed' }}
                  />
                </DatePickerCell>
                {dateConfig.cut_off_from_date && (
                  <button
                    type="button"
                    className="delete is-small"
                    disabled={disabled}
                    onClick={() => {
                      const newConfig = [...config];
                      newConfig[index] = {
                        ...newConfig[index],
                        cut_off_from_date: null,
                      };
                      onChange(newConfig);
                    }}
                  />
                )}
              </div>
            </td>
            <td>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <TimePickerCell>
                  <SelectTime
                    value={dateConfig.cut_off_from_time}
                    disabled={disabled}
                    onChange={value => {
                      const newConfig = [...config];
                      newConfig[index] = {
                        ...newConfig[index],
                        cut_off_from_time: value.time,
                      };
                      onChange(newConfig);
                    }}
                  />
                </TimePickerCell>
                {dateConfig.cut_off_from_time && (
                  <button
                    type="button"
                    className="delete is-small"
                    disabled={disabled}
                    onClick={() => {
                      const newConfig = [...config];
                      newConfig[index] = {
                        ...newConfig[index],
                        cut_off_from_time: null,
                      };
                      onChange(newConfig);
                    }}
                  />
                )}
              </div>
            </td>
            <td>
              <DatePickerCell style={{ width: '190px' }}>
                <ReactDateTimePicker
                  value={dateConfig.cut_off_date}
                  onChange={value => {
                    const newConfig = [...config];
                    newConfig[index] = {
                      ...newConfig[index],
                      cut_off_date: value,
                    };
                    onChange(newConfig);
                  }}
                  disabled={disabled || !dateConfig.date}
                  minDate={new Date()}
                  popperProps={{ strategy: 'fixed' }}
                />
              </DatePickerCell>
            </td>
            <td>
              <TimePickerCell>
                <SelectTime
                  value={dateConfig.cut_off_time}
                  disabled={disabled}
                  onChange={value => {
                    const newConfig = [...config];
                    newConfig[index] = {
                      ...newConfig[index],
                      cut_off_time: value.time,
                    };
                    onChange(newConfig);
                  }}
                />
              </TimePickerCell>
            </td>
            <td>
              <div style={{ display: 'flex', gap: 4 }}>
                {index === config.length - 1 ? (
                  <button
                    type="button"
                    className="button is-small"
                    onClick={onAdd}
                    disabled={disabled}
                  >
                    <span className="icon is-small">
                      <i className="fas fa-plus" />
                    </span>
                  </button>
                ) : (
                  <div style={{ width: 28 }} />
                )}
                {config.length > 1 ? (
                  <button
                    type="button"
                    className="button is-small"
                    onClick={() => {
                      const newConfig = [...config];
                      newConfig.splice(index, 1);
                      onChange(newConfig);
                    }}
                    disabled={disabled}
                  >
                    <span className="icon is-small">
                      <i className="fas fa-trash" />
                    </span>
                  </button>
                ) : (
                  <div style={{ width: 28 }} />
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </StyledTable>
  </TableContainer>
);

const dayOptions = {
  SUN: { label: 'SUN', value: 'SUN' },
  MON: { label: 'MON', value: 'MON' },
  TUE: { label: 'TUE', value: 'TUE' },
  WED: { label: 'WED', value: 'WED' },
  THU: { label: 'THU', value: 'THU' },
  FRI: { label: 'FRI', value: 'FRI' },
  SAT: { label: 'SAT', value: 'SAT' },
};

const dayDict = {
  Sunday: 'SUN',
  Monday: 'MON',
  Tuesday: 'TUE',
  Wednesday: 'WED',
  Thursday: 'THU',
  Friday: 'FRI',
  Saturday: 'SAT',
};

const CateringMenuSetting = ({ values, setFieldValue, errors, touched }) => {
  console.log(values, errors);

  const [modalStep, setModalStep] = useState(null); // null | 'select' | 'range'
  const [rangeFrom, setRangeFrom] = useState(null);
  const [rangeTo, setRangeTo] = useState(null);

  const openModal = (fromRadio = false) => {
    if (fromRadio) {
      setFieldValue('specific_dates_config', []);
    }
    setModalStep('select');
  };

  const closeModal = () => {
    setModalStep(null);
    setRangeFrom(null);
    setRangeTo(null);
  };

  const addSingleDate = () => {
    const newConfig = [...(values.specific_dates_config || [])];
    newConfig.push({
      date: null,
      is_active: true,
      option: {},
      cut_off_date: null,
      cut_off_time: null,
      cut_off_from_date: null,
      cut_off_from_time: null,
    });
    setFieldValue('specific_dates_enabled', true);
    setFieldValue('specific_days_enabled', false);
    setFieldValue('lead_type', 'DAYS');
    setFieldValue('specific_dates_config', newConfig);
    setFieldValue('schedule_order_duration', 365);
    closeModal();
  };

  const addDateRange = () => {
    if (!rangeFrom || !rangeTo) return;
    const start = moment(rangeFrom).startOf('day');
    const end = moment(rangeTo).startOf('day');

    const existingDates = new Set(
      (values.specific_dates_config || [])
        .filter(c => c.date)
        .map(c => moment(c.date).format('YYYY-MM-DD')),
    );

    const duplicates = [];
    const newEntries = [];
    const current = start.clone();
    while (current.isSameOrBefore(end, 'day')) {
      const dateStr = current.format('YYYY-MM-DD');
      if (existingDates.has(dateStr)) {
        duplicates.push(dateStr);
      } else {
        newEntries.push({
          date: dateStr,
          is_active: true,
          option: {
            end: '11:59 PM',
            end_in_sec: 86340,
            start: '12:00 AM',
            start_in_sec: 0,
            type: null,
          },
          cut_off_date: null,
          cut_off_time: null,
          cut_off_from_date: null,
          cut_off_from_time: null,
        });
      }
      current.add(1, 'day');
    }

    if (duplicates.length > 0) {
      toast.error(
        `Cannot add dates that already exist: ${duplicates.join(', ')}`,
      );
      return;
    }
    setFieldValue('specific_dates_enabled', true);
    setFieldValue('specific_days_enabled', false);
    setFieldValue('lead_type', 'DAYS');
    setFieldValue('schedule_order_duration', 365);
    setFieldValue('specific_dates_config', [
      ...(values.specific_dates_config || []),
      ...newEntries,
    ]);
    closeModal();
  };

  return (
    <Container>
      <br />
      <Field className="is-flex">
        <Label className="is-flex">
          Catering Menu&nbsp;&nbsp;{' '}
          <CheckBox
            onChange={() => {
              setFieldValue('is_catering_menu', !values.is_catering_menu);
              if (!values.is_catering_menu === false) {
                setFieldValue('schedule_order_in_advance', false);
                setFieldValue('is_note', false);
                setFieldValue('lead_time', 0);
                setFieldValue('schedule_order_duration', 0);
                setFieldValue('menu_cut_off_time', '');
                setFieldValue('notes', '');
              }
            }}
            value={values.is_catering_menu}
          />
        </Label>
      </Field>

      <GridContainer>
        <Label className="is-flex">Lead Type</Label>
        <Radio
          label="Days"
          value={
            values.lead_type === 'DAYS' &&
            values.specific_days_enabled === false &&
            values.specific_dates_enabled === false
          }
          onChange={v => {
            if (v) {
              setFieldValue('lead_type', 'DAYS');
              setFieldValue('specific_days_enabled', false);
              setFieldValue('specific_dates_enabled', false);
            } else {
              setFieldValue('lead_type', 'HOURS');
              setFieldValue('menu_cut_off_time', '');
            }
          }}
          disabled={!values.is_catering_menu}
        />
        <Radio
          label="Hours"
          value={values.lead_type === 'HOURS'}
          onChange={v => {
            if (v) {
              setFieldValue('lead_type', 'HOURS');
              setFieldValue('menu_cut_off_time', '');
              setFieldValue('specific_days_enabled', false);
              setFieldValue('specific_dates_enabled', false);
            } else {
              setFieldValue('lead_type', 'DAYS');
            }
          }}
          disabled={!values.is_catering_menu}
        />
        <Radio
          label="Specific Day"
          value={values.specific_days_enabled}
          onChange={v => {
            if (v) {
              setFieldValue('specific_days_enabled', true);
              setFieldValue('specific_dates_enabled', false);
              setFieldValue('lead_type', 'DAYS');
            }
          }}
          disabled={!values.is_catering_menu}
        />
        <Radio
          label="Specific Date"
          value={values.specific_dates_enabled}
          onChange={v => {
            if (v) {
              openModal(true);
            }
          }}
          disabled={!values.is_catering_menu}
          stopClickFn
        />
        <div />
        {values.specific_days_enabled === false &&
          values.specific_dates_enabled === false && (
            <>
              <Label className="is-flex">Lead Time</Label>
              <InputAddOn
                type="number"
                min="0"
                step="1"
                onChange={e => setFieldValue('lead_time', e.target.value)}
                value={values.lead_time}
                disableToastMessage
                errors={errors.lead_time}
                touched={touched.lead_time}
                required
                disabled={values.is_catering_menu === false}
              />
              <Label className="is-flex">Cut Off Time</Label>
              <SelectTime
                value={values.menu_cut_off_time}
                onChange={e => setFieldValue('menu_cut_off_time', e.time)}
                disabled={
                  values.is_catering_menu === false ||
                  values.lead_type === 'HOURS'
                }
              />
              <InputErrorMessage
                errors={errors.menu_cut_off_time}
                touched={touched.menu_cut_off_time}
                disableToastMessage
              />
              <div />
            </>
          )}
      </GridContainer>
      <br />
      <br />
      {values.specific_dates_enabled === true && (
        <>
          <SpecificDatesTable
            config={values.specific_dates_config}
            disabled={
              !values.is_catering_menu || !values.specific_dates_enabled
            }
            onChange={newConfig =>
              setFieldValue('specific_dates_config', newConfig)
            }
            onAdd={() => openModal(false)}
          />
          <br />
          <br />
        </>
      )}
      {values.specific_days_enabled === true && (
        <>
          <GridContainer2>
            {[
              'Sunday',
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
            ].map(ele => (
              <>
                <div style={{ justifySelf: 'end' }}>
                  <CheckBox
                    value={!!values.specific_days_config[dayDict[ele]]}
                    onChange={() => {
                      if (values.specific_days_config[dayDict[ele]]) {
                        setFieldValue('specific_days_config', {
                          ...values.specific_days_config,
                          [dayDict[ele]]: null,
                        });
                      } else {
                        setFieldValue('specific_days_config', {
                          ...values.specific_days_config,
                          [dayDict[ele]]: {
                            day: dayDict[ele],
                            is_active: true,
                            option: {},
                          },
                        });
                      }
                    }}
                    disabled={
                      !values.is_catering_menu || !values.specific_days_enabled
                    }
                  />
                </div>
                <p className="is-size-5 has-text-weight-semibold mt-1">
                  Order for {ele}
                </p>
                <SelectTime
                  value={
                    values.specific_days_config[dayDict[ele]]?.option?.start
                  }
                  disabled={
                    !values.is_catering_menu ||
                    !(
                      values.specific_days_enabled &&
                      values.specific_days_config[dayDict[ele]]
                    )
                  }
                  onChange={value => {
                    const temp = {
                      ...values.specific_days_config[dayDict[ele]],
                    };

                    const start_in_sec =
                      value.hours * 3600 + value.minutes * 60;

                    if (temp.option) {
                      temp.option.start = value.time;
                      temp.option.start_in_sec = start_in_sec;
                    } else {
                      temp.option = {};
                      temp.option.start = value.time;
                      temp.option.start_in_sec = start_in_sec;
                    }

                    setFieldValue('specific_days_config', {
                      ...values.specific_days_config,
                      [dayDict[ele]]: temp,
                    });
                  }}
                />
                <Label style={{ justifySelf: 'center' }} className="mt-2">
                  to
                </Label>
                <SelectTime
                  value={values.specific_days_config[dayDict[ele]]?.option?.end}
                  disabled={
                    !values.is_catering_menu ||
                    !(
                      values.specific_days_enabled &&
                      values.specific_days_config[dayDict[ele]]
                    )
                  }
                  onChange={value => {
                    const temp = {
                      ...values.specific_days_config[dayDict[ele]],
                    };

                    const end_in_sec = value.hours * 3600 + value.minutes * 60;

                    if (temp.option) {
                      temp.option.end = value.time;
                      temp.option.end_in_sec = end_in_sec;
                    } else {
                      temp.option = {};
                      temp.option.end = value.time;
                      temp.option.end_in_sec = end_in_sec;
                    }

                    setFieldValue('specific_days_config', {
                      ...values.specific_days_config,
                      [dayDict[ele]]: temp,
                    });
                  }}
                />
                <Label style={{ justifySelf: 'center' }} className="mt-2">
                  Cut Off Day
                </Label>
                <Select
                  value={
                    dayOptions[
                      values.specific_days_config[dayDict[ele]]?.cut_off_day
                    ]
                  }
                  options={Object.values(dayOptions)}
                  disabled={
                    !values.is_catering_menu ||
                    !(
                      values.specific_days_enabled &&
                      values.specific_days_config[dayDict[ele]]
                    )
                  }
                  onChange={value => {
                    const temp = {
                      ...values.specific_days_config[dayDict[ele]],
                    };

                    temp.cut_off_day = value.value;

                    setFieldValue('specific_days_config', {
                      ...values.specific_days_config,
                      [dayDict[ele]]: temp,
                    });
                  }}
                />
                <Label style={{ justifySelf: 'center' }} className="mt-2">
                  Cut Off Time
                </Label>
                <SelectTime
                  value={
                    values.specific_days_config[dayDict[ele]]?.cut_off_time
                  }
                  disabled={
                    !values.is_catering_menu ||
                    !(
                      values.specific_days_enabled &&
                      values.specific_days_config[dayDict[ele]]
                    )
                  }
                  onChange={value => {
                    const temp = {
                      ...values.specific_days_config[dayDict[ele]],
                    };

                    temp.cut_off_time = value.time;

                    setFieldValue('specific_days_config', {
                      ...values.specific_days_config,
                      [dayDict[ele]]: temp,
                    });
                  }}
                />
                <div />
              </>
            ))}
          </GridContainer2>
          <br />
          <br />
        </>
      )}
      {!values.specific_dates_enabled && (
        <InputAddOn
          label="Advance Order Days"
          type="number"
          min="0"
          step="1"
          disableToastMessage
          required
          value={values.schedule_order_duration}
          onChange={e =>
            setFieldValue('schedule_order_duration', e.target.value)
          }
          disabled={values.is_catering_menu === false}
          errors={errors.schedule_order_duration}
          touched={touched.schedule_order_duration}
        />
      )}
      <GridContainer>
        <Label className="is-flex">Payment Options&nbsp;&nbsp;</Label>
        <Radio label="Full Payment" value />
        <div />
        <div />
        <div />
        <div />
        <Radio label="Partial Payment" value={false} disabled />
        <InputAddOn type="number" min="0" step="1" disabled />
      </GridContainer>
      <div>
        <Label className="is-flex">
          Publish Catering Terms and Conditions&nbsp;&nbsp;
          <CheckBox
            onChange={() => {
              setFieldValue('is_note', !values.is_note);
            }}
            value={values.is_note}
          />
        </Label>
        <TextArea
          name="notes"
          label="Catering Terms and Conditions"
          disableToastMessage
          value={values.notes}
          onChange={e => setFieldValue('notes', e.target.value)}
          disabled={values.is_catering_menu === false}
          errors={errors.notes}
          touched={touched.notes}
          optionalText="(Min 5 and Max 500 Characters)"
        />
        {values.notes && (
          <div style={{ textAlign: 'right' }}>
            {values.notes.length > 500 || values.notes.length < 5
              ? ''
              : `Characters left ${500 - values.notes.length}`}
          </div>
        )}
      </div>
      {modalStep && (
        <div className="modal is-active">
          <div className="modal-background" onClick={closeModal} />
          <div className="modal-card">
            {modalStep === 'select' && (
              <>
                <header className="modal-card-head">
                  <p className="modal-card-title">Add Specific Dates</p>
                  <button
                    type="button"
                    className="delete"
                    onClick={closeModal}
                  />
                </header>
                <section className="modal-card-body">
                  <p>How would you like to add dates?</p>
                </section>
                <footer className="modal-card-foot" style={{ gap: '0.5rem' }}>
                  <button
                    type="button"
                    className="button is-primary"
                    onClick={() => setModalStep('range')}
                  >
                    Add by Range
                  </button>
                  <button
                    type="button"
                    className="button is-info"
                    onClick={addSingleDate}
                  >
                    Add by Date
                  </button>
                  <button type="button" className="button" onClick={closeModal}>
                    Cancel
                  </button>
                </footer>
              </>
            )}
            {modalStep === 'range' && (
              <>
                <header className="modal-card-head">
                  <p className="modal-card-title">Select Date Range</p>
                  <button
                    type="button"
                    className="delete"
                    onClick={closeModal}
                  />
                </header>
                <section
                  className="modal-card-body"
                  style={{ minHeight: '320px' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                    }}
                  >
                    <Label style={{ marginBottom: 0 }}>From</Label>
                    <DatePickerCell style={{ width: '190px' }}>
                      <ReactDateTimePicker
                        value={rangeFrom}
                        onChange={value => {
                          setRangeFrom(value);
                          if (
                            rangeTo &&
                            moment(value).isAfter(moment(rangeTo))
                          ) {
                            setRangeTo(null);
                          }
                        }}
                        minDate={new Date()}
                      />
                    </DatePickerCell>
                    <Label style={{ marginBottom: 0 }}>To</Label>
                    <DatePickerCell style={{ width: '190px' }}>
                      <ReactDateTimePicker
                        value={rangeTo}
                        onChange={value => setRangeTo(value)}
                        minDate={rangeFrom ? new Date(rangeFrom) : new Date()}
                        disabled={!rangeFrom}
                      />
                    </DatePickerCell>
                  </div>
                </section>
                <footer className="modal-card-foot" style={{ gap: '0.5rem' }}>
                  <button
                    type="button"
                    className="button is-primary"
                    onClick={addDateRange}
                    disabled={!rangeFrom || !rangeTo}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="button"
                    onClick={() => setModalStep('select')}
                  >
                    Back
                  </button>
                </footer>
              </>
            )}
          </div>
        </div>
      )}
    </Container>
  );
};

export default CateringMenuSetting;
